import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormModal,
  FormInput,
} from "../../../../../../onestep-library/BaseUI/";
import {
  updateNewPaymentSourceField,
  submitNewPaymentSourceFromStripe,
  submitNewCardPaymentSourceFromPaySimple,
  submitNewBankAccountSourceFromPaysimple,
} from "./actions";
import { injectStripe } from "react-stripe-elements";

function NewPaymentSourceForm(props) {
  const creditCardInputRef = React.useRef(null);
  const { stripe } = props;
  const dispatch = useDispatch();
  const [cardValidation, setCardValidation] = React.useState(true);
  const {
    ui,
    kind,
    routing_number,
    account_number,
    account_holder_type,
    errors,
    account_holder_name,
    company_name,
  } = useSelector((state) => state.newPaymentSourceForm);
  const { payment_processor } = useSelector((state) => state.organization);
  const organization = useSelector((state) => state.organization);
  const { show, is_submitting, callback_action } = ui;
  const updateNewPaymentSourceFieldAction = (payload) =>
    dispatch(updateNewPaymentSourceField(payload));

  const paymentTypeOptions = React.useMemo(() => {
    let options = [];
    if (organization["cc_enabled?"])
      options.push({ label: "Card", value: "card" });
    if (organization["ach_enabled?"])
      options.push({ label: "Bank Account", value: "bank_account" });

    return options;
  }, [organization]);

  function onClose() {
    dispatch({ type: "RESET_NEW_PAYMENT_SOURCE_FORM" });
    dispatch({ type: callback_action, payload: { show: true } });
    dispatch({
      type: "SET_NEW_PAYMENT_SOURCE_CALLBACK_ACTION",
      payload: { callback_action: undefined },
    });
  }

  function onValidateRequiredFields() {
    return (
      !!kind &&
      ((kind === "card" &&
        (!(payment_processor == "paysimple") || cardValidation)) ||
        (kind === "bank_account" &&
          routing_number.length > 0 &&
          account_number.length > 0 &&
          !!account_holder_type))
    );
  }

  function onSubmit() {
    dispatch({ type: "BEGIN_SUBMIT_NEW_PAYMENT_SOURCE" });
    if (payment_processor == "stripe") {
      dispatch(
        submitNewPaymentSourceFromStripe({ stripe, handleClose: onClose })
      );
    } else if (payment_processor == "paysimple") {
      if (kind == "card") creditCardInputRef.current.submit();
      if (kind == "bank_account")
        dispatch(
          submitNewBankAccountSourceFromPaysimple({ handleClose: onClose })
        );
    }
  }

  function onErrors() {}

  function handleKindChange(payload) {
    updateNewPaymentSourceFieldAction({
      ...payload,
      routing_number: "",
      account_number: "",
      account_holder_type: "",
      card_number: undefined,
    });
  }

  return (
    <FormModal
      show={show}
      title="New Payment Source"
      isSubmitting={is_submitting}
      submitButtonLabel="Create Payment Source"
      errors={errors}
      handleClose={onClose}
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleErrors={onErrors}
    >
      <FormInput
        type="select"
        label="Kind"
        options={paymentTypeOptions}
        handleChange={(kind) => handleKindChange({ kind: kind.value })}
      />
      {kind === "card" && (
        <>
          {payment_processor == "stripe" && (
            <FormInput type="credit_card_stripe" />
          )}
          {payment_processor == "paysimple" && (
            <FormInput
              ref={creditCardInputRef}
              type="credit_card_paysimple"
              setCardValidation={setCardValidation}
              handlePaymentMethodSucceeded={(paySimple) =>
                dispatch(
                  submitNewCardPaymentSourceFromPaySimple({
                    handleClose: onClose,
                    paySimple,
                  })
                )
              }
            />
          )}
        </>
      )}
      {kind === "bank_account" && (
        <div>
          <FormInput
            type="number"
            label="Routing Number"
            value={routing_number}
            handleChange={(routing_number) =>
              updateNewPaymentSourceFieldAction({ routing_number })
            }
          />
          <FormInput
            type="number"
            label="Account Number"
            value={account_number}
            handleChange={(account_number) =>
              updateNewPaymentSourceFieldAction({ account_number })
            }
          />
          {payment_processor == "paysimple" && (
            <FormInput
              label="Account Holder Name"
              value={account_holder_name}
              handleChange={(account_holder_name) =>
                updateNewPaymentSourceFieldAction({ account_holder_name })
              }
            />
          )}
          <FormInput
            type="select"
            label="Account Holder Type"
            options={
              payment_processor == "paysimple"
                ? [
                    { label: "Checking", value: "checking" },
                    { label: "Savings", value: "savings" },
                    { label: "Business Checking", value: "business_checking" },
                  ]
                : [
                    { label: "Individual", value: "individual" },
                    { label: "Company", value: "company" },
                  ]
            }
            handleChange={(account_holder_type) =>
              updateNewPaymentSourceFieldAction({
                account_holder_type: account_holder_type.value,
              })
            }
          />
          {account_holder_type == "business_checking" && (
            <FormInput
              label="Company Name"
              value={company_name}
              handleChange={(company_name) =>
                updateNewPaymentSourceFieldAction({ company_name })
              }
            />
          )}
        </div>
      )}
    </FormModal>
  );
}

export default injectStripe(NewPaymentSourceForm);
